import { Divider, Tab, Tabs } from "@mui/material";
import { useTranslation } from "react-i18next";

const SecondaryTabs = ({ selected, setSelected, options }) => {
  const { t } = useTranslation();
  const tabs = options.flatMap((o, i) => {
    if (i < options.length - 1) {
      return [o, {}];
    } else {
      return [o];
    }
  });
  return (
    <Tabs value={selected} onChange={(_, newValue) => setSelected(newValue)} tone="Secondary" sx={{ height: 24 }}>
      {tabs.map((tab, i) => {
        if (tab.value) {
          return (
            <Tab
              key={i}
              onClick={() => {
                setSelected(tab.value);
              }}
              label={t(tab.label)}
              value={tab.value}
              variant="Secondary"
            />
          );
        } else if (tab.label) {
          return (
            <Tab
              key={i}
              onClick={() => {
                setSelected(tab.label);
              }}
              label={t(tab.label)}
              value={tab.label}
              variant="Secondary"
            />
          );
        } else {
          return <Tab key={i} disabled icon={<Divider orientation="vertical" />} variant="Secondary Disabled" />;
        }
      })}
    </Tabs>
  );
};

export default SecondaryTabs;
